import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { FormattedMessage, injectIntl, intlShape } from '../../../util/reactIntl';
import { Form as FinalForm } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import classNames from 'classnames';
import { Form, PrimaryButton, FieldTextInput } from '../../../components';

import css from './YoutubeSection.module.scss';

const YoutubeSectionFormComponent = props => (
  <FinalForm
    {...props}
    mutators={{ ...arrayMutators }}
    initialValues={props.initialValues}
    render={fieldRenderProps => {
      const {
        rootClassName,
        className,
        formId,
        handleSubmit,
        intl,
        invalid,
      } = fieldRenderProps;

      const classes = classNames(rootClassName || css.root, className);
      const submitDisabled = false;

      return (
        <Form
          className={classes}
          onSubmit={handleSubmit}
        >
          <div className={css.dynamicFieldWrapper}>
            <label className={css.dynamicItemLabel}>
              <FormattedMessage id="EditListingPhotosForm.youtubeMessage" />
            </label>
            <FieldTextInput
              name="link"
              className={css.dynamicField}
              component="input"
              placeholder={intl.formatMessage({
                id: 'EditListingPhotosForm.youtubePlaceholder',
              })}
            />

            <label className={css.dynamicItemLabel}>
              <FormattedMessage id="EditListingPhotosForm.videoMessage" />
            </label>
            <FieldTextInput
              name="title"
              className={css.dynamicField}
              component="input"
              placeholder={intl.formatMessage({
                id: 'EditListingPhotosForm.videoPlaceholder',
              })}
            />
          </div>
          <PrimaryButton type="submit" disabled={submitDisabled}>
            <FormattedMessage id="ListingPage.savePost" />
          </PrimaryButton>
        </Form>
      );
    }}
  />
);

YoutubeSectionFormComponent.defaultProps = {
  rootClassName: null,
  className: null,
  form: null,
};

const { string, bool } = PropTypes;

YoutubeSectionFormComponent.propTypes = {
  rootClassName: string,
  className: string,
  form: string,
  intl: intlShape.isRequired,
};

const YoutubeSectionForm = compose(injectIntl)(YoutubeSectionFormComponent);
YoutubeSectionForm.displayName = 'YoutubeSectionForm';

export default YoutubeSectionForm;
